var _defs, _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pitGrad",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b3722d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a4f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fleshGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f7f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6fa33e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#d4e38c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e5f3b7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 20c-90 0-170 100-170 200s80 210 170 210 170-110 170-210S346 20 256 20z",
    fill: "url(#fleshGrad)",
    stroke: "#2d4d1a",
    strokeWidth: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 260,
    r: 90,
    fill: "url(#pitGrad)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 230,
    r: 20,
    fill: "rgba(255,255,255,0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5949a2f081ce990d8f9b2db8b236a5f8.svg";
export { ForwardRef as ReactComponent };